/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Cross_Desc5Inputs */

const en_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One codebase that ships to both App Store and Play Store via React Native/Expo, faster to launch, cheaper to maintain.`)
};

const ar_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كود واحد يصل إلى متجر التطبيقات ومتجر بلاي عبر React Native/Expo, أسرع إطلاقًا وأرخص صيانةً.`)
};

const bn_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React Native/Expo দিয়ে এক কোডবেস থেকেই App Store ও Play Store, দুটোর জন্য অ্যাপ শিপ করুন। লঞ্চ দ্রুত হবে, রক্ষণাবেক্ষণের খরচও কমবে।`)
};

const de_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Codebasis, die über React Native/Expo sowohl an den App Store als auch an den Play Store geliefert wird, schneller zu starten und kostengünstiger zu warten ist.`)
};

const es_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una base de código que se envía tanto a App Store como a Play Store a través de React Native/Expo, más rápido de lanzar y más económico de mantener.`)
};

const fr_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une base de code livrée à la fois sur l'App Store et le Play Store via React Native/Expo, plus rapide à lancer, moins chère à maintenir.`)
};

const pt_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma base de código publicada na App Store e Play Store via React Native/Expo, lançamento mais rápido e manutenção mais barata.`)
};

const zh_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个代码库，通过 React Native/Expo 发布到 App Store 和 Play Store，启动速度更快，维护成本更低。`)
};

const tr_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React Native/Expo ile hem App Store'a hem Play Store'a çıkan tek kod tabanı, daha hızlı lansman, daha ucuz bakım.`)
};

const ru_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Единая кодовая база, выходящая и в App Store, и в Play Store на React Native/Expo,, быстрее запуск, дешевле поддержка.`)
};

const pl_svc_mobile_app_development_cross_desc5 = /** @type {(inputs: Svc_Mobile_App_Development_Cross_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jedna baza kodu dostarczana zarówno do App Store, jak i Play Store za pośrednictwem React Native/Expo, szybsza do uruchomienia i tańsza w utrzymaniu.`)
};

/**
* | output |
* | --- |
* | "One codebase that ships to both App Store and Play Store via React Native/Expo, faster to launch, cheaper to maintain." |
*
* @param {Svc_Mobile_App_Development_Cross_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_cross_desc5 = /** @type {((inputs?: Svc_Mobile_App_Development_Cross_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Cross_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "de") return de_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "es") return es_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_cross_desc5(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_cross_desc5(inputs)
	return en_svc_mobile_app_development_cross_desc5(inputs)
});
export { svc_mobile_app_development_cross_desc5 as "svc_mobile-app-development_CROSS_desc" }